<template>
    <div class="placeholder-card">
        <div class="thumbnail gradient" />
        <div class="top-info">
            <div class="placeholder-category-pill gradient" />
        </div>
        <div class="article-text"></div>
        <div class="tags">
            <div class="placeholder-tag gradient" />
        </div>
    </div>
</template>

<style lang="scss">
    @use '~/assets/styles/variables' as *;
    .placeholder-card {
        width: auto;
        display: flex;
        flex-direction: column;
        position: relative;
        height: 450px;

        .gradient {
            animation-duration: 1.8s;
            animation-fill-mode: forwards;
            animation-iteration-count: infinite;
            animation-name: placeHolderShimmer;
            animation-timing-function: linear;
            background: #f6f7f8;
            background: linear-gradient(to right, #fafafa 8%, #f4f4f4 38%, #fafafa 54%);
            background-size: 1000px 640px;

            position: relative;
        }
        @keyframes placeHolderShimmer {
            0% {
                background-position: -468px 0;
            }
            100% {
                background-position: 468px 0;
            }
        }
        .thumbnail {
            width: 100%;
            height: 240px;
            object-fit: cover;
            background-color: var(--joy-color-neutral-30);
        }

        .top-info {
            margin-top: var(--joy-core-spacing-4);
            display: flex;
            justify-content: space-between;
            align-items: center;
            .placeholder-category-pill {
                height: 24px;
                width: 80px;
                border-radius: 24px;
                background-color: var(--joy-color-neutral-30);
            }
        }
        .article-text {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

        .tags {
            margin-top: var(--joy-core-spacing-4);
            display: flex;
            gap: var(--joy-core-spacing-1);
            .placeholder-tag {
                height: 24px;
                width: 80px;
                border-radius: var(--joy-core-border-radius-2);
                background-color: var(--joy-color-neutral-30);
            }
        }
    }
</style>
